export default __webpack_public_path__ + "static/ville-sherbrooke-3ccd1e3d5a43c102fe4a444229b17a4a.png";